import axios from "axios";
export default axios.create({
  baseURL: process.env.VUE_APP_ROOT_API,
  // baseURL: "http://dealeco-back.rhinosme-stagging.com/api/index.php",
  // baseURL: 'http://local.dealeco.com:8888/api/index.php',
  headers: {
    "Content-type": "application/json"
  }
});